<div class="container">
	<div class="content-blocks--video">
		<ng-container>
			<youtube-player [videoId]="params.code"></youtube-player>
		</ng-container>
	</div>
</div>
